import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve } from '../../../../helpers/LinkMapper';

const fieldSchema = {
    "reimbursementId": [ resolve.with(Number) ],
    "status": [ resolve.with(String) ],
    "amountRefunded": [ resolve.with(Number) ]
};

class ReimbursementResponse extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(ReimbursementResponse, json, getResolvers(fieldSchema));
    }
}

export default ReimbursementResponse;
